<ps-ui-modal>
  <div class="ps-modal-header" psUiModalTitle>
    <h5>Remove supHashId Upload History</h5>
  </div>
  <ps-ui-modal-body>
    <div class="history-actions">
      <button type="button" psUiButton (click)="getHistory()">Refresh</button>
    </div>
    <div class="table-responsive sup-hash-removal-history">
      <table class="table table-sm table-bordered">
        <thead>
          <tr>
            <th>File Name</th>
            <th>Requested By</th>
            <th>Uploaded Date</th>
            <th>Status</th>
            <th>Progress</th>
            <th>Total</th>
            <th>Valid</th>
            <th>Invalid</th>
            <th>Verified</th>
            <th>Mismatch</th>
            <th>Verification Failed</th>
            <th>Removed</th>
            <th>Not Found</th>
            <th>Partial</th>
            <th>Failed</th>
            <th>Error</th>
            <th>Report</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="isLoading && !jobs.length">
            <td colspan="17">Loading...</td>
          </tr>
          <tr *ngFor="let job of jobs">
            <td>{{ job.fileName || '-' }}</td>
            <td>{{ job.requestedBy || '-' }}</td>
            <td>{{ job.createdAt | date : 'medium' }}</td>
            <td>{{ displayStatus(job) }}</td>
            <td>
              <div class="progress-value">{{ progress(job) }}%</div>
              <div class="progress-track">
                <div class="progress-bar" [style.width.%]="progress(job)"></div>
              </div>
            </td>
            <td>{{ job.totalRows || 0 }}</td>
            <td>{{ job.validRows || 0 }}</td>
            <td>{{ job.invalidRows || 0 }}</td>
            <td>{{ job.verifiedRows || 0 }}</td>
            <td>{{ job.mismatchRows || 0 }}</td>
            <td>{{ job.verificationFailedRows || 0 }}</td>
            <td>{{ job.removedRows || 0 }}</td>
            <td>{{ job.notFoundRows || 0 }}</td>
            <td>{{ job.partiallyRemovedRows || 0 }}</td>
            <td>{{ job.failedRows || 0 }}</td>
            <td>{{ job.errorMessage || '-' }}</td>
            <td>
              <button
                type="button"
                class="report-button"
                [disabled]="!job.reportAvailable || !!downloadingJobId"
                (click)="downloadReport(job)"
              >
                {{
                  downloadingJobId === job.jobId ? 'Downloading...' : 'Download'
                }}
              </button>
            </td>
          </tr>
          <tr *ngIf="!isLoading && !jobs.length">
            <td colspan="17">No supHashId removal history found.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </ps-ui-modal-body>
  <ps-ui-modal-footer position="center">
    <button type="button" class="close-btn" (click)="close()">Close</button>
  </ps-ui-modal-footer>
</ps-ui-modal>
